import Journey from '../components/journey/Journey';

export default [
  {
    name: 'Journey',
    path: '/journey',
    component: Journey,
  },
]
